import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { requests, formDataHeaders, instance } from "../../utils/api/api.service";
import { INSTITUTIONS_URL } from "../../utils/api/endpoints";
import { IInstitution } from "../../shared/interfaces/institution/IInstitution";

export const InstitutionService = {
  getAll: (params: IPagination): Promise<IBaseModel<IInstitution[]>> =>
    requests.get(INSTITUTIONS_URL, params),
  getSingle: (id: number) => requests.get(`${INSTITUTIONS_URL}/${id}`),
  create: (payload: IInstitution, id?: number, file?: File | null) => {
    const formData = new FormData();
    // Send the entire object as JSON under 'request' key
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    formData.append('request', blob);
    if (file) {
      formData.append('file', file);
    }
    return requests.post(INSTITUTIONS_URL, formData, formDataHeaders);
  },
  update: (payload: IInstitution, id?: number): Promise<IInstitution> =>
    requests.put(`${INSTITUTIONS_URL}/${id}`, payload),
  delete: (id: number) => requests.delete(`${INSTITUTIONS_URL}/${id}`),
  uploadImage: (id: number, file: FormData) =>
    requests.post(`${INSTITUTIONS_URL}/${id}/image`, file, formDataHeaders),
  getImageBlob: async (id: number, width?: number, height?: number): Promise<string | null> => {
    const params = new URLSearchParams();
    if (width) params.append('width', width.toString());
    if (height) params.append('height', height.toString());
    const queryString = params.toString() ? `?${params.toString()}` : '';
    
    try {
      const response = await instance.get(`${INSTITUTIONS_URL}/${id}/image${queryString}`, {
        responseType: 'blob',
      });
      
      if (response.data && response.data.size > 0) {
        return URL.createObjectURL(response.data);
      }
      return null;
    } catch (error) {
      console.error('Failed to fetch institution image blob:', error);
      return null;
    }
  },
};
